import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../date-time-schema';

export const SCHEDULING_TYPE = {
  ACTUALS_ONLY: 'ACTUALS_ONLY',
  PLANNED_AND_ACTUALS: 'PLANNED_AND_ACTUALS',
} as const;

export const schedulingTypeSchema = z.enum(SCHEDULING_TYPE);

export const itemScheduleDatesSchema = z.object({
  forecastedStartDateTime: isoUtcDateTimeSchema.optional(),
  forecastedFinishDateTime: isoUtcDateTimeSchema.optional(),
  latestFinishDateTime: isoUtcDateTimeSchema.optional(),
});

export type SchedulingType = z.infer<typeof schedulingTypeSchema>;
export type ItemScheduleDatesDTO = z.infer<typeof itemScheduleDatesSchema>;
